/*
  DisabledUsersData - stores the denied teachers in a separate table as incase teacher can later be recovered by the admin
*/
import { db } from "../firebase/config";
import {
  collection,
  addDoc,
} from "firebase/firestore";

const userCollectionRef = collection(db, "disabledusers");

export const disableUser = async (
  instructor
) => {
  await addDoc(userCollectionRef, {
    department: instructor.department,
    email: instructor.email,
    id: instructor.id,
    isVerified: false,
    name: instructor.name,
    num: instructor.num,
    role: instructor.role,
    disabled: true,
  });
};

